import React from 'react'
import { Container, Player,Video} from './styles'

export const PlayerVideo = ({idevento}) => {

    const playAudio = async (idAudio) => {
        //await logAudio(idAudio, 'Play')
    }
    const clickPause = async (idAudio) => {
        //await logAudio(idAudio,'Pause')
    }   

    const logAudioEnd = async (idAudio) => {
        //await logAudio(idAudio,'End')
    }
    

    return (
    <Container>
                <Player id="staticPlayer">
                    <Video width="100%" height="100%" 
                        controls 
                        onPlay={e => playAudio(1)}
                        onPause={e=> clickPause(1)}
                        onEnded={e=> logAudioEnd(1)} >
                        <source src={`https://webinars.spinmedia.es/${process.env.REACT_APP_EVENT_PATH}/eventos/video/${idevento}.mp4`} type="video/mp4" />
                    </Video>
                </Player>
    </Container> 
    )
}